import telemetry from 'legacy-src/utility/telemetry';
import { openSecureBrowserLink } from 'legacy-src/components/apstudent/handlers/Assignments/lockdownbrowser';
import {
  timeLeftUntilCbSessionTimeout,
  timeLeftUntilCBSessionExpire,
} from 'legacy-src/components/auth/utils';

const GET_FEEDBACK = 'GET FEEDBACK';
const SCORE = 'SCORE';

/**
 * @deprecated - should be removed or replaced by the legacy version
 * - legacy version has the latest functionality
 * */
class AssignmentOpen {
  constructor(props, setSecureAssessmentOnMobile) {
    this.props = props;
    this.setSecureAssessmentOnMobile = setSecureAssessmentOnMobile;
    this.onTimedAssessmentClick = this.onTimedAssessmentClick.bind(this);
  }

  /**
   * Click handler for the Begin button for a timed assignment
   * @param {Object} assignment The assignment object
   */
  onTimedAssessmentClick(
    assignment,
    showTimedAssignmentWarning,
    checkCBSessionFlag,
    cbSessionExpirationOverride = false,
    levityUseCreateTime,
  ) {
    const useCreateTimeOrExpireTime = levityUseCreateTime
      ? timeLeftUntilCbSessionTimeout()
      : timeLeftUntilCBSessionExpire();
    // hard override only used for debugging, should remain off, see FY-12447
    const expirationTimeDiff =
      cbSessionExpirationOverride || useCreateTimeOrExpireTime;
    const { timer } = assignment;
    const expiringSession = expirationTimeDiff <= timer;

    // if expire time less than assignment timer, render the cb session expiration warning
    if (checkCBSessionFlag && showTimedAssignmentWarning && expiringSession) {
      this.beginAssignment(assignment);
      // if user has no expiration time, render the regular timed assessment warning
      // if no expiration time, we assume it's a direct login and render the regular timed assessment warning
      // if expire time greater than assignment timer, render the regular timed assessment warning
    } else if (checkCBSessionFlag && showTimedAssignmentWarning) {
      return {
        isTimedAssignment: true,
      };
    } else {
      this.beginAssignment(assignment);
    }
  }

  /**
   * Get the assignment URL by its id
   * @param {Number/String} assignmentId
   * @returns {String}
   **/
  getAssignmentUrl({ id, is_secure, secure_link, link, headline }) {
    const { params } = this.props;
    return is_secure && headline !== GET_FEEDBACK && headline !== SCORE
      ? secure_link
      : id
        ? `/${params.subject}/assessments/assignments/${id}`
        : `/${link}`;
  }

  /**
   * Called when any assignment button has been clicked
   * @param {Number/String} assignmentId
   * @param {Object} assignment
   * @returns {String}
   **/
  @telemetry((props, state, args) => {
    const [assignment_id, assignment, title] = args;
    const { progress = {} } = assignment || {};
    const event_type = progress.started
      ? 'continue_assessment'
      : 'begin_assessment';

    return {
      event_type,
      params: {
        element: title ? 'title' : 'button',
        assignment_id,
      },
    };
  })

  // eslint-disable-next-line class-methods-use-this
  triggerDecorator() {
    // Return true to get the telemetry decorator triggered
    return true;
  }

  /**
   * Navigates to a given assignment by its id
   * @param {String} assignment
   * @param {String} returnPath
   **/
  beginAssignment(assignment, returnPath = '') {
    const { router, isLdbEnabled, isMobileDevice } = this.props;
    const url = this.getAssignmentUrl(assignment);
    const { headline, is_secure } = assignment;
    if (isLdbEnabled && is_secure && headline !== GET_FEEDBACK) {
      // PREAP-1483: if we require a secure browser url, the url provided is expected to be an ldb1 protocol. We'll need to check
      // that this host actually has it installed.
      if (isMobileDevice) {
        this.setSecureAssessmentOnMobile(true);
      } else {
        this.triggerDecorator();
        this.openSecureBrowserTimeoutId = openSecureBrowserLink(
          url,
          this.onBrowserStatusChange,
          this.openSecureBrowserTimeoutId,
          router,
        );
      }
    } else {
      this.triggerDecorator();
      let urlLoc = {
        pathname: url,
      };
      if (returnPath) {
        urlLoc.state = {
          returnPath,
        };
      }
      router.push(urlLoc);
    }
  }
}

export default AssignmentOpen;
